import { useEffect, useState } from 'react';
import { messages } from './messages';
import { matchPlatformLanguage } from './languages';
import { getPlatformLanguage, subscribePreferences } from './preferences';

export function usePlatformLanguage() {
  const [language, setLanguage] = useState(() => getPlatformLanguage());
  useEffect(() => {
    const update = () => setLanguage(getPlatformLanguage());
    update();
    return subscribePreferences(update);
  }, []);
  return language;
}

export function usePlatformCopy() {
  const language = usePlatformLanguage();
  return messages[matchPlatformLanguage(language)?.code ?? 'en'];
}
